export default __webpack_public_path__ + "static/media/modalbg.83cc59d6.jpg";